import { Storage } from "aws-amplify";

export const put = async (file) =>
  await Storage.put(file.name, file, {
    contentType: file.type,
    level: "private",
  });
